module.exports = __webpack_public_path__ + "img/sn.1540f65a.svg";